<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div [fxFlex]="labelFlex">
    {{ textLabel | translate }}*
  </div>

  <div [fxFlex]="formWrapperFlex">
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          required
          #campaign_distributionInput
          formControlName="campaign_distribution" 
          [matAutocomplete]="campaign_distributionAC" 
          (focus)="!campaign_distributionAC.isOpen && getInitialValues('campaign_distribution')" 
          >

        <mat-icon *ngIf="campaign_distributionInput.value" matSuffix svgIcon="close-circle-outline" (click)="clearForm($event)"></mat-icon>

        <mat-icon matSuffix svgIcon="menu-down" *ngIf="!campaign_distributionInput.value"></mat-icon>

        <mat-autocomplete #campaign_distributionAC="matAutocomplete" [displayWith]="displayFn" (closed)="autoCmpltClosed(); campaign_distributionInput.blur()">
          <mat-option
            disabled
            *ngIf="!loading.campaign_distribution && listData?.length == 0"
            >
            {{ 'MSG_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData" 
            [matTooltip]="data.distribution_code + ' - ' + data.distribution_description"
            >
            {{ data.campaign_code }} - {{ data.campaign_description }}
            {{ data.distribution_code }} - {{ data.distribution_description }}
          </mat-option>

          <mat-option *ngIf="loading.campaign_distribution" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('campaign_distribution').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('campaign_distribution').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: ('LABEL_CAMPAIGN' | translate) + '/' + ('LABEL_DISTRIBUTION' | translate) } }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>